import { NEW_EMPLOYEE } from '../../../components/layout/navConfig';

/**
 * Who may run the guided new-employee flow.
 *
 * It needs three separate server permissions at once, and no single existing
 * role constant is the right shape:
 *
 *   createGate            (POST /api/admin/people)      admin, super_admin, coordinator, hr
 *   ONBOARDING_ACCESS     (assign onboarding content)   admin, super_admin, onboarding, hr
 *   editGate              (GET the person it lands on)  admin, super_admin, coordinator, hr
 *
 * NEW_EMPLOYEE is the intersection. A coordinator would stall at step 2
 * (cannot assign) and the onboarding role would be locked out of the record
 * the wizard finishes on, so both are steered elsewhere rather than let in
 * and failed part way through.
 *
 * Deliberately reads the same constant the nav uses, so the entry points and
 * the route gate cannot drift apart.
 */
export function canRunWizard(roles: readonly string[]): boolean {
  return roles.some((r) => NEW_EMPLOYEE.includes(r));
}
